<template>
    <div class="grid-item grid-item-half position-relative">
        <v-inline-loader v-if="isLoadingLogo" />
        <img class="image organization-logo" :src="logoUrl" :alt="organization.name" v-if="hasLogo && !isLoadingLogo"/>
    </div>
</template>

<script>
    import vInlineLoader from '@/components/v-inline-loader';
    import OrganizationModel from '@/common/models/organization-model';
    import isBlank from '@/common/helpers/is-blank';

    export default {
        name: 'organization-logo',
        components: {vInlineLoader},
        props: {
            organization: {
                type: OrganizationModel,
                required: true,
            },
        },
        data() {
            return {
                isLoadingLogo: false,
                logoUrl: null,
            };
        },
        computed: {
            hasLogo() {
                return !isBlank(this.logoUrl);
            },
        },
        methods: {
            async loadLogo() {
                if (this.organization.id) {
                    await this.getAttachment();
                }
            },
            async getAttachment() {
                this.isLoadingLogo = true;
                try {
                    const {items, total} = await this.$api(({files}) => files.getAllAttachments({
                        filter: `relatedId:${this.organization.id};relatedType:organization`,
                        sort: '-createdTime',
                    }));
                    if (total > 0) {
                        const [attachment] = items;
                        const {fields} = await this.$api(({files}) => files.get({id: attachment.fields.fileId}));
                        /* eslint-disable no-underscore-dangle */
                        this.logoUrl = fields._links.find(link => link.rel === 'signedLink').href;
                    }
                } catch (error) {
                    this.$toast.fromError(error);
                } finally {
                    this.isLoadingLogo = false;
                }
            },
        },
        created() {
            this.loadLogo();
        },
        watch: {
            organization() {
                this.loadLogo();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .organization-logo {
        height: 66px;
        width: auto;
    }
</style>
